// ComingSoon.jsx
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./ComingSoon.css"

const ComingSoon = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="modal coming-soon show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content text-center">
          <div className="modal-header">
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            Coming Soon
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
